<template>
  <div class="lot-info">
    <div>
      <h2 class="block__subtitle mb-10">
        {{ lot.id }}
      </h2>
      <h3 class="lot-info__subtitle block__subtitle-small">
        {{ lot?.name }}
      </h3>
    </div>
    <div class="lot-info__right">
      <div v-if="lot?.deleted_at && (isSecurity || isAdmin)" class="lot-info__deleted">
        <span class="lot-info__deleted-text">Удален</span>
        <div class="lot-info__deleted-info">
          <span class="lot-info__deleted-date">{{ lot?.deleted_at }}</span>
          <span class="lot-info__deleted-separator" />
          <router-link
            v-if="lot?.deletedBy"
            :to="{
              name: isAdmin ? 'admin-user' : 'security-user',
              params: { id: lot.deletedBy?.id },
            }"
            class="btn btn-link btn-link-classic"
            >{{ lot.deletedBy.name }}
          </router-link>
          <span v-else>Пользователь отсутствует</span>
        </div>
      </div>
      <div v-if="isOrganizer">
        <v-link
          v-if="checkCurrentStatus([1, 3, 4])"
          class="mb-20 ml-a normal-weight"
          icon="Edit"
          @click="goChangeLot">
          Редактировать
        </v-link>
        <button class="btn btn-primary btn-primary--padding btn-bg-green" @click="openVModal">
          Фиктивный участник
        </button>
      </div>
    </div>
  </div>

  <div class="p-30 bg--yellow mb-20 status__info">
    <StatusInfo :info="dateInfo" type="bidder--lot" />
    <div
      v-if="(isSecurity || isAdmin) && [8, 9, 10, 11, 12].includes(lot?.status.id)"
      class="status__download-buttons">
      <button
        class="btn btn-primary btn-bg-transparent btn-primary--padding"
        @click="downloadOriginal">
        <v-icon icon-name="LoadFile" width="33" height="33" class="mr-10" />
        Оригинал
      </button>
      <button
        v-if="lot?.has_modified_table"
        class="btn btn-primary btn-bg-transparent btn-primary--padding"
        @click="downloadChange">
        <v-icon icon-name="LoadFile" width="33" height="33" class="mr-10" />
        Изменения
      </button>
      <div v-if="(isSecurity || isAdmin) && lot?.results?.length" class="protocols">
        <button
          class="btn btn-primary btn-bg-transparent btn-primary--padding btn-bg-green"
          @click="showProtocols = !showProtocols">
          <v-icon icon-name="LoadFile" width="33" height="33" class="mr-10" />
          <span class="mr-10">Протокол</span>
          <v-icon icon-name="Arrow" width="11" height="7" />
        </button>
        <div v-if="showProtocols" class="protocols__content">
          <div class="protocols__item" @click="downloadAllProtocols">Скачать все</div>
          <div
            v-for="item in lot.results"
            :key="item.id"
            class="protocols__item"
            @click="downloadProtocol(item.id)">
            Протокол {{ item.id }}.pdf
          </div>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <TheModalFictiveBidder v-if="isOrganizer" :is-open="showVModal" :close-modal="closeVModal" />
  </teleport>
</template>

<script>
import StatusInfo from '@/components/statusElements/VStatusInfo'
import TheModalFictiveBidder from '@/components/ui/modal/lot/TheModalFictiveBidder'
import { checkCurrentStatus } from '@/utils/lot/function.lot'
import { lotInfoProps } from '@/mixin/props'
import { useRouter } from 'vue-router'
import useVModal from '@/use/Base/useVModal'
import VLink from '@/components/ui/buttons/VLink'
import { useStore } from 'vuex'
import VIcon from '@/components/ui/icon/VIcon.vue'
import { inject, ref } from 'vue'
import { BIDDING_CONTROLLER } from '@/utils/consts'

export default {
  components: {
    VIcon,
    VLink,
    StatusInfo,
    TheModalFictiveBidder,
  },
  mixins: [lotInfoProps],
  props: {
    dateInfo: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const showProtocols = ref(false)
    const biddingController = inject(BIDDING_CONTROLLER)
    const store = useStore()
    const isSecurity = store.getters['auth/isSecurity']
    const isAdmin = store.getters['auth/isAdmin']

    const router = useRouter()
    const downloadOriginal = async () => {
      await biddingController.downloadExcelResultOrigin(props.lot.id)
    }
    const downloadChange = async () => {
      await biddingController.downloadExcelResultModified(props.lot.id)
    }
    const downloadProtocol = async (id) => {
      await biddingController.downloadPDFProtocolResult(id)
    }

    const downloadAllProtocols = async () => {
      const ids = props.lot?.results?.map((result) => result.id) || []

      if (!ids.length) return

      await biddingController.downloadPDFProtocolsResults(ids)
    }

    const goChangeLot = () => {
      router.push({ name: 'edit-trade', params: { id: props.lot.id } })
    }

    return {
      downloadAllProtocols,
      showProtocols,
      downloadOriginal,
      downloadChange,
      downloadProtocol,
      isAdmin,
      isSecurity,
      goChangeLot,
      checkCurrentStatus,
      ...useVModal(),
    }
  },
}
</script>

<style lang="scss" scoped>
.lot-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;
  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  &__deleted-text {
    align-self: end;
    color: white;
    padding: 6px;
    background-color: #e30202;
    border-radius: 100px;
  }
  &__deleted-separator {
    border-right: 1px solid #899787;
  }
  &__deleted-info {
    display: flex;
    gap: 8px;
  }
  &__deleted {
    display: flex;
    gap: 10px;
    flex-direction: column;
  }
}

.protocols {
  position: relative;
  &__content {
    top: 80px;
    right: 0;
    display: flex;
    flex-direction: column;
    width: 466px;
    background: white;
    position: absolute;
    z-index: 5;
    box-shadow: 0 20px 40px 0 #233f1f29;
  }
  &__content::before {
    content: '';
    position: absolute;
    top: -20px;
    right: 80px;
    width: 30px;
    height: 22px;
    background: url('~@/assets/icon/triangle_white.svg') no-repeat;
  }
  &__item {
    font-size: 20px;
    cursor: pointer;
    padding: 12px;
    height: 50px;
    display: flex;
    width: 100%;
    transition: background-color 0.2s ease-in-out;
    align-items: center;
    &:hover {
      background-color: #ffed00;
    }
  }
}
.status__info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.status__download-buttons {
  display: flex;
  gap: 10px;
}
</style>
